import * as React from 'react';
import { Element, scroller } from 'react-scroll';
import { Helmet } from 'react-helmet';

import { connect } from 'react-redux';
import { bindActionCreators } from '../../node_modules/redux';
import { withRouter } from 'react-router';

import authActions from '../auth/authActions';

import HomePageAssessment from './HomePageAssessment';
import HomePageAssessmentBottom from './HomePageAssessmentBottom';
import { Page } from '../components/common';
import { SectionLeft, SectionMain, SectionRight } from '../components/sections';
import Button from '../components/buttons/Button';
import { IconArrowDown, LogoFirstCanadian, IconTriangleRight } from '../components/icons';
const scorLogoSrc = require('../assets/images/logo-scor.png');

interface Props {
	actions: any;
	history: any;
	currentUser: UserDetails;

}
class HomePage extends React.Component<Props, any> {
	constructor(props: Props) {
		super(props);
	}

	componentDidMount() {
		if (this.props.currentUser.isAuthenticated) {
			if (this.props.currentUser.role !== undefined) {
				if (this.props.currentUser.role[0] !== 'Customer') {
					if (this.props.currentUser.role.some(r => r === 'Adjudicator')) {
						return this.props.history.push('/admin/adjudication');
					} else {
						return this.props.history.push('/admin');
					}
				}
				else if (!this.props.currentUser.hasBeenDirected) {
					this.props.actions.doneDirect(this.props.currentUser);
					return this.props.history.push('/user');
				}
			}
		}
	}

	onAltCtaClick = () => {
		let topOffset = 15;
		const navbar = document.querySelector('.navbar-wrapper.fixed-top');

		if (navbar) {
			topOffset += navbar.clientHeight;
		}

		scroller.scrollTo('homePageAssessment', {
			duration: 300,
			smooth: true,
			offset: -topOffset
		});
	}

	render() {
		return (
			<Page>
				<Helmet>
					<meta charSet="utf-8" />
					<meta
						name="description"
						content="Simple. Direct. Affordable. Discover your life insurance options in just 10 minutes and apply for up to $1 million in coverage."
					/>
					<title>Mosaic Life - Simple & Affordable Life Insurance for Canadians</title>
				</Helmet>
				<header
					className="page-hero page-hero-lg"
					role="img"
					aria-label="A man holding a small child on a dock by a lake"
				>
					<div className="page-hero-content">
						<div className="container">
							<div className="row">
								<div className="col-md-5 text-light d-flex flex-column justify-content-center">
									<div>
										<h1 className="page-hero-title page-title-display mb-0 mb-md-2">
											Simple and affordable life insurance for Canadians
										</h1>
										<h2 className="h3 my-3 max-read-width text-white d-flex bg-info-dark px-3 py-2">
											<IconTriangleRight className="mr-1 text-white" />
											<span>Sign up today and get your first two months free!</span>
										</h2>
										<p className="mb-0 page-hero-lead max-read-width">
											Protect your family and their future in less than 10 minutes for 10 years or more. Up to
											a million dollars for as little as $1.50 a day with no in-home medical assessment required.
										</p>
										<Button
											className="btn-primary btn-primary-inverse my-3 page-hero-cta-alt"
											onClick={this.onAltCtaClick}
										>
											Get started
											<IconArrowDown className="ml-2" />
										</Button>
									</div>
								</div>
								<div className="col-md-6 offset-md-1 mt-3 mt-md-0 px-0 d-flex flex-column justify-content-center">
									<Element name="homePageAssessment" />
									<SectionRight columns={12} sectionClassName="pr-0">
										<HomePageAssessment />
									</SectionRight>
								</div>
							</div>
						</div>
					</div>
				</header>
				<div className="container my-4 my-md-6">
					<section className="card-deck">
						<div className="card">
							<div className="card-body section section-lg">
								<h2 className="mb-3">Simple</h2>
								<p className="mb-0">
									Unlike other insurers, we don't require medical exams or urine samples. You can get coverage in 10
									minutes, all online.
								</p>
							</div>
						</div>
						<div className="card">
							<div className="card-body section section-lg">
								<h2 className="mb-3">Direct</h2>
								<p className="mb-0">
									We’ve cut out the middlemen to give you an experience that’s free of hefty fees, commissions, and complexity.
								</p>
							</div>
						</div>
						<div className="card">
							<div className="card-body section section-lg">
								<h2 className="mb-3">Affordable</h2>
								<p className="mb-0">
									By skipping pricey broker commissions and taking insurance online, we’re able to offer $1 million of coverage for as little as $1.50/day.
								</p>
							</div>
						</div>
					</section>
				</div>
				<div className="mt-4 mt-md-0 pt-md-6 landing-section">
					<div
						className="landing-section-img landing-section-img-01 landing-section-img-right"
						role="img"
						aria-label="A woman, young child, and dog playing in a lake surrounded by an evergreen forest"
					/>
					<SectionLeft columns={8} sectionClassName="section-lg">
						<h2 className="mb-3">How Mosaic Life Works</h2>
						If you're young & healthy (the best time to buy life insurance), getting protection from Mosaic Life is simple:
						<ol className="custom-ol">
							<li>
								<div className="custom-ol-content">
									Choose a term and coverage amount (if you're unsure, <a href="/quote/B/about-you">we can help</a>).
								</div>
							</li>
							<li>
								<div className="custom-ol-content">Answer some quick lifestyle and health questions.</div>
							</li>
							<li>
								<div className="custom-ol-content">Get an instant decision and sign up.</div>
							</li>
						</ol>
						<p>
							Once you're covered, if you die during the term of your protection, your loved ones will receive your
							coverage amount.
						</p>
						<p>
							You can apply for up to $1 million of coverage, and it's easy to add or cancel policies if your needs change.
							If you change your mind during the first 30 days, you can cancel your policy and get a full refund.
						</p>
						<Button to="/faq" className="btn-outline-primary mt-3">
							Learn more
						</Button>
					</SectionLeft>
				</div>
				<section className="mt-4 mt-md-6 container d-none d-lg-block">
					<h2 className="mb-3">Why Choose Mosaic Life</h2>
					<div className="row row-x-1">
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container" onTouchStart={(e) => e}>
								<div className="flipper">
									<h3 className="front">Convenient and easy</h3>
									<div className="back">
										Most insurers require you to provide blood and urine samples and can take weeks to issue a policy.
										With Mosaic Life, you can get coverage in 10 minutes just by answering some lifestyle and health
										questions online.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Direct</h3>
									<div className="back">
										We don’t rely on brokers or agents to sell our policies which means we don't pay sales commissions.
										We pass those savings on to you.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Team Canada</h3>
									<div className="back">Mosaic Life is proudly for Canadians, by Canadians.</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Affordable</h3>
									<div className="back">
										By skipping pricey broker commissions and dealing with you directly instead, we're able to offer better rates than our competitors.
										You can get up to $1 million in coverage starting at ~$1.50/day.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Guaranteed rates</h3>
									<div className="back">
										Your premiums are set for the term of your policy. Even if you get sick during your policy term,
										your premiums will not change.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Relevant</h3>
									<div className="back">
										We launched Mosaic Life out of our own need for protection. We've reimagined how life insurance
										should work&mdash;100% online, totally flexible, no brokers, simple.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Cancel anytime (with money-back guarantee)</h3>
									<div className="back">
										You can cancel your policy at any time and for any reason. If you cancel in the first 30 days, we
										will give you a full refund of your premium.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">No fees</h3>
									<div className="back">
										Besides your monthly premium, there are no additional fees to obtain coverage.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Flexible</h3>
									<div className="back">
										We offer a range of terms and coverage amounts to meet your specific needs. You can have up to $1
										million in total coverage across as many policies as you would like.
									</div>
								</div>
							</div>
						</div>
						<div className="col-md-6 col-lg-3 mb-2 px-1">
							<div className="flip-container">
								<div className="flipper">
									<h3 className="front">Insurance you can trust</h3>
									<div className="back">
										We try to be honest, transparent, and helpful. Your privacy is important to us.
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<SectionMain sectionClassName="mt-4 mt-md-6 section-lg">
					<div className="row align-items-center">
						<div className="col-md-5 col-lg-4 text-center">
							<LogoFirstCanadian className="landing-section-logo landing-section-logo-fc" />
						</div>
						<div className="col-md-7 col-lg-8 mt-4 mt-md-0">
							<p>
								Mosaic Life policies are underwritten by First Canadian Insurance Corporation, a life insurer based in Edmonton that has
								provided protection to over 1 million Canadian families.  First Canadian has been around for over 30 years and is rated
								A (with stable outlook) by A.M. Best, the leading ratings agency for insurance companies.
							</p>
						</div>
					</div>
					<div className="row align-items-center mt-4 mt-md-5">
						<div className="col-md-5 col-lg-4 text-center">
							<img src={scorLogoSrc} alt="The logo of SCOR (The Art & Science of Risk)" className="landing-section-logo landing-section-logo-scor" />
						</div>
						<div className="col-md-7 col-lg-8 mt-4 mt-md-0 order-md-first">
							<p>
								Mosaic Life is also backed by SCOR, one of the world’s largest reinsurers and a leader in the creation
								of innovative risk management solutions for insurance companies. SCOR has been around for almost 50
								years and is rated A+ (with stable outlook) by A.M. Best.
							</p>
						</div>
					</div>
				</SectionMain>
				<section className="mt-4 mt-md-6 section section-lg bg-secondary text-light">
					<div className="container">
						<HomePageAssessmentBottom />
					</div>
				</section>
			</Page>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		currentUser: state.auth.currentUser
	};
}

function mapDispatchToProps(dispatch: any) {
	const actions = { ...authActions };
	return {
		actions: bindActionCreators(actions, dispatch),
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomePage));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/HomePage.tsx